export interface Filter {
    checkboxes: { [name: string]: string[]; },
    inputs: { [name: string]: string; }
}

export const emptyFilter = (): Filter => {
    return {
        checkboxes: {},
        inputs: {}
    }
}